import moment from 'moment';
import { PagesRoutes } from '../../../../routing/PagesRoutes';
import { settings as shipmentSettingsModel } from '../../../../models/entities/shipment/shipment';
import StyledLink from '../../../shared/SmallComponents/StyledLink';
import { styled } from '../../../shared/Theme/theme';
import { ConsolidationEventRow } from './consolidationUtils';

type Props = {
    events: ConsolidationEventRow[];
    settings?: shipmentSettingsModel;
    localization?: any;
};

const ConsolidationEventsTable = ({ events, settings, localization }: Props) => {
    const resolveEventName = (eventCode?: string) => {
        if (!eventCode) return '-';
        const match = settings?.eventTypes?.find((item) => item.code === eventCode);
        return match?.name || eventCode;
    };

    if (!events.length) {
        return <EmptyMessage>No events recorded for shipments in this consolidation.</EmptyMessage>;
    }

    return (
        <TableWrap>
            <Table>
                <thead>
                    <tr>
                        <Th>Shipment</Th>
                        <Th>Event</Th>
                        <Th>Description</Th>
                        <Th>User</Th>
                        <Th>Date</Th>
                    </tr>
                </thead>
                <tbody>
                    {events.map((ev) => (
                        <tr key={String(ev.id)}>
                            <Td>
                                <StyledLink to={`${PagesRoutes.Shipments}/${ev.shipmentId}`}>{ev.shipmentNumber}</StyledLink>
                            </Td>
                            <Td>{resolveEventName(ev.eventCode)}</Td>
                            <Td $wrap>
                                {localization?.events?.descriptions?.[ev.eventCode] || ev.description || '-'}
                            </Td>
                            <Td>{ev.userName || '-'}</Td>
                            <Td>{ev.eventDate ? moment(ev.eventDate).format('DD/MM/YYYY HH:mm') : '-'}</Td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </TableWrap>
    );
};

const TableWrap = styled.div`
    width: 100%;
    overflow-x: auto;
    background: #fff;
    border-radius: 8px;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    font-size: ${(props) => props.theme.fontSizes.gridCell};
    color: ${(props) => props.theme.colors.gridCell};
`;

const Th = styled.th`
    padding: 10px 12px;
    text-align: left;
    font-weight: 500;
    font-size: 13px;
    color: ${(props) => props.theme.colors.gridResultsCounter};
    background: #f5f6f8;
    border-top: 1px solid #e8e8e8;
    vertical-align: middle;
`;

const Td = styled.td<{ $wrap?: boolean }>`
    padding: 12px;
    text-align: left;
    vertical-align: middle;
    white-space: ${(props) => (props.$wrap ? 'normal' : 'nowrap')};
    overflow: hidden;
    text-overflow: ellipsis;
`;

const EmptyMessage = styled.p`
    margin: 0;
    padding: 24px 12px;
    color: ${(props) => props.theme.colors.lightGray};
    font-size: ${(props) => props.theme.fontSizes.gridCell};
    background: #fff;
    border-radius: 8px;
`;

export default ConsolidationEventsTable;
